import { Topic } from './topics';

export enum MHTopic {
	TALK_THERAPY = 'talk_therapy',
	MEDICATION_MANAGEMENT = 'anxiety_and_depression',
	THERAPY_AND_MEDICATION = 'therapy_and_medication',
	MENTAL_HEALTH_LETTER = 'mental_health_letter',
	ADHD = 'adhd',
}

export enum MHTopicId {
	mhm = 'mhm',
	mht = 'mht',
	vc = 'vc',
	mhl = 'mhl',
}

export default <Topic[]>[
	{
		name: 'Talk Therapy',
		id: MHTopic.TALK_THERAPY,
		altId: 'mh_therapy',
	},
	{
		name: 'Anxiety & Depression',
		id: MHTopic.MEDICATION_MANAGEMENT,
		altId: 'mh_medication',
	},
	{
		name: 'ADHD',
		id: MHTopic.ADHD,
		altId: 'adhd',
	},
	{
		name: 'Mental Health Surgery Letter',
		id: MHTopic.MENTAL_HEALTH_LETTER,
		altId: 'mh-letter',
	},
];
